import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex gap-10 flex-col max-w-7xl mx-auto justify-center mt-28 ml-[22.5%]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl uppercase font-semibold text-[#322121] dark:text-white" }, " View Sliders ", -1)
const _hoisted_3 = { class: "relative h-full w-full sm:rounded-lg" }
const _hoisted_4 = {
  key: 0,
  class: "w-full border dark:border-gray-600 text-sm text-left text-gray-500 dark:text-gray-400"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Title"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "View Slider"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Edit"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3"
    }, "Delete")
  ])
], -1)
const _hoisted_6 = { class: "px-6 py-4" }
const _hoisted_7 = {
  scope: "row",
  class: "px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
}
const _hoisted_8 = { class: "px-6 py-4" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "font-medium text-blue-600 dark:text-blue-500 hover:underline" }, "Edit")
], -1)
const _hoisted_11 = { class: "px-6 py-4" }
const _hoisted_12 = ["onClick"]

import { url, imagesUrl } from '@/functions/endpoint';
import axios from 'axios';
import { ref, watch } from 'vue';
import { decodeEntities } from "@/functions";
import { useRouter } from 'vue-router';
import DeleteModal from "@/components/DeleteModal.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Loader from "@/components/Loader.vue";
import EmptyState from "@/components/EmptyState.vue";
import { Pagination } from 'flowbite-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewSliders',
  setup(__props) {

const sliderId = ref();
const router = useRouter()
let successMessage = ref('');
let showSuccessMessage = ref(false);
const loading = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');
const perPage = ref(12);
const currentPage = ref(1);
let emptyState = ref(false);

const calculatePostNumber = (index: number) => {
  return (currentPage.value - 1) * perPage.value + index + 1;
};

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
  sliderId.value = id;
  deleteModal.value = true;
};

const closeDeleteModal = () => {
  deleteModal.value = false;
};

const deleteSlider = async () => {
  try {
    const response = await axios.delete( `${url}/slider/delete/${sliderId.value}`
    );

    deleteModal.value = false;
    successMessage = response.data;
    showSuccessMessage.value = true;

    const deletedIndex = allSliders.value.findIndex((item: any) => item.id === sliderId.value);
    if (deletedIndex !== -1) {
      allSliders.value.splice(deletedIndex, 1);
    }

    setTimeout(() => {
      showSuccessMessage.value = false;
    }, 2000);
  } catch (error: any) {
    deleteModal.value = false;
    errorAlert.value = true;
    errorMessage.value = error.message;

    setTimeout(() => {
      errorAlert.value = false;
    }, 2500);
  }
};

const allSliders: any = ref([]);
const fetchNewsItems = () => {
  loading.value = true;
  axios
    .get(`${url}/slider`, {
      params: {
        page: currentPage.value,
        limit: perPage.value
      }
    })
    .then((response: any) => {
      allSliders.value = response.data[1];
    })
    .catch((error: string) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    })
};

watch(currentPage, fetchNewsItems);
fetchNewsItems();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSliders.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(calculatePostNumber(index)), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(item?.title?.slice(0, 80)), 1),
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: `${_unref(imagesUrl)}/uploads/${item.image}`
                      }, "View Slider", 8, _hoisted_9)
                    ]),
                    _hoisted_10,
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (openDeleteModal(item.id)),
                        class: "font-medium text-red-600 dark:text-red-500 hover:underline"
                      }, "Delete", 8, _hoisted_12)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createBlock(Loader, {
              key: 1,
              class: "my-52"
            })),
        _createVNode(EmptyState, { showEmptyState: _unref(emptyState) }, null, 8, ["showEmptyState"])
      ])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteSlider,
          onCloseDeleteModal: closeDeleteModal,
          item: 'slider'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})